import React from "react"
import Actividad from "./Actividad"
import Riesgo from "./Riesgo"
import Accion from "./Accion"
import Incidente from "./Incidente"

export default function Actualizacion({ location }) {
    let { tarea } = location.state

    return (
        <div >
            {tarea.tipo === "Accion" && <Accion a={tarea.id} />}
            {tarea.tipo === "Riesgo" && <Riesgo r={tarea.id} />}
            {tarea.tipo === "Incidente" && <Incidente i={tarea.id} />}
            {tarea.tipo === "Actividad" && <Actividad a={tarea.id} p={tarea.proyecto} />}
        </div>
    )
}